<template>
  <b-form-group
    label="Vizyonumuz"
    label-for="vision"
  >
    <validation-provider
      #default="{ errors }"
      name="Vizyonumuz"
      rules="required"
    >
      <b-form-textarea
        id="vision"
        v-model="itemData.vision"
        placeholder="Vizyonumuz"
        rows="10"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormTextarea } from 'bootstrap-vue'

export default {
  name: 'VisionContent',
  components: {
    BFormGroup,
    BFormTextarea,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['about/dataItem']
    },
  },
}
</script>
